"use strict";var findIndex = require('core-js-pure/features/array/find-index');

function isRadio() {
  return this.type === 'radio';
}

function getCheckedValues() {var _this = this;
  if (this.isRadio()) {
    var item = this.input.items[this.state.checkedIndex] || {};
    return [item.value];
  }
  return this.input.items.
  filter(function (item, index) {return _this.state.checkedItems[index];}).
  map(function (item) {return item.value;});
}

function getCheckedIndexes() {var _this2 = this;
  if (this.isRadio()) {
    return [this.state.checkedIndex];
  }
  return this.input.items.
  map(function (item, i) {return _this2.state.checkedItems[i] && i;}).
  filter(function (item) {return item !== false && typeof item !== 'undefined';});
}

function getInputState(input) {
  this.type = input.type;
  if (this.isRadio()) {
    return {
      checkedIndex: findIndex(input.items || [], function (item) {return item.checked || false;}) };

  }
  return {
    checkedItems: (input.items || []).map(function (item) {return item.checked || false;}) };

}

function isChecked(index) {
  if (this.isRadio()) {
    return index === this.state.checkedIndex;
  }
  return this.state.checkedItems[index];
}

function toggleChecked(index) {
  if (Array.isArray(index)) {
    if (this.isRadio()) {
      this.state.checkedIndex = index[0];
    } else {
      this.state.checkedItems = this.state.checkedItems.map(
      function (item, i) {return index.indexOf(i) !== -1;});

    }
    return;
  }

  if (this.isRadio() && index !== this.state.checkedIndex) {
    this.state.checkedIndex = index;
  } else if (this.type !== 'radio') {
    this.state.checkedItems[index] = !this.state.checkedItems[index];
    this.setStateDirty('checkedItems');
  }
}

module.exports = {
  isRadio: isRadio,
  getInputState: getInputState,
  isChecked: isChecked,
  getCheckedIndexes: getCheckedIndexes,
  getCheckedValues: getCheckedValues,
  toggleChecked: toggleChecked };